import { useTheme } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import type { FC, ReactNode } from "react";
import { HeaderIconButton } from "web_myplann/Shared/Header/HeaderIconButton";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

type Props = {
	title: string;
	onBack: () => void;
	center?: boolean;
	children: ReactNode;
};

export const PaperworkStepLayout: FC<Props> = ({
	title,
	onBack,
	center,
	children,
}) => {
	const { palette } = useTheme();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={palette.grey[50]}
			mainSx={
				center
					? {
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
						}
					: undefined
			}
			topBar={
				<NavigationHeader
					title={title}
					bgColor={palette.background.appBar}
					startComponent={
						<HeaderIconButton onClick={onBack}>
							<ArrowLeft color={palette.primary.main} />
						</HeaderIconButton>
					}
				/>
			}
		>
			{children}
		</MyPlannLayout>
	);
};
